export const ArrowLeft = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0699 19.2901C9.87994 19.2901 9.68994 19.2201 9.53994 19.0701L3.46994 13.0001C3.17994 12.7101 3.17994 12.2301 3.46994 11.9401L9.53994 5.87009C9.82994 5.58009 10.3099 5.58009 10.5999 5.87009C10.8899 6.16009 10.8899 6.64009 10.5999 6.93009L5.05994 12.4701L10.5999 18.0101C10.8899 18.3001 10.8899 18.7801 10.5999 19.0701C10.4599 19.2201 10.2599 19.2901 10.0699 19.2901Z"
      fill="#6B7280"
    />
    <path
      d="M20.9999 13.22H4.16992C3.75992 13.22 3.41992 12.88 3.41992 12.47C3.41992 12.06 3.75992 11.72 4.16992 11.72H20.9999C21.4099 11.72 21.7499 12.06 21.7499 12.47C21.7499 12.88 21.4099 13.22 20.9999 13.22Z"
      fill="#6B7280"
    />
  </svg>
);
